import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import MainLayout from "../../layout/MainLayout";

const AirClientEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Fetch client by ID
  useEffect(() => {
    const fetchClient = async () => {
      try {
        const res = await axios.get(`https://bpohasil.ngrok.app/api/air-client/${id}`);
        setClient(res.data.client);
      } catch (err) {
        setError("Failed to fetch client data.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchClient();
  }, [id]);

  // Handle form changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setClient((prev) => ({ ...prev, [name]: value }));
  };

  // Handle update (PUT request)
  const handleUpdate = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      await axios.put(`https://bpohasil.ngrok.app/api/air-client/${id}`, client);
      alert("Client updated successfully!");
      navigate("/scanner"); // Go back to list or desired page
    } catch (err) {
      console.error(err);
      setError("Failed to update client data.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="text-gray-600">Loading client data...</p>;
  if (error) return <p className="text-red-600">{error}</p>;
  if (!client) return <p>No client found.</p>;

  return (
    <MainLayout>
    <div className="max-w-2xl mx-auto bg-white shadow-md rounded-lg p-6 mt-6">
      <h2 className="text-2xl font-bold mb-4 text-gray-700">
        Edit Air Client
      </h2>

      <form onSubmit={handleUpdate} className="grid grid-cols-2 gap-4 text-sm">
        {/* ID (read-only) */}
        <div className="col-span-2">
          <label className="block text-gray-600">ID</label>
          <input
            type="text"
            name="id"
            value={client.id || ""}
            readOnly
            className="border rounded-md w-full p-2 bg-gray-100"
          />
        </div>

        <div>
          <label className="block text-gray-600">Nama</label>
          <input
            type="text"
            name="name"
            value={client.name || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">No Akaun</label>
          <input
            type="text"
            name="accountNumber"
            value={client.accountNumber || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Kod Kawasan</label>
          <input
            type="text"
            name="areaCode"
            value={client.areaCode || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Nama Kawasan</label>
          <input
            type="text"
            name="areaName"
            value={client.areaName || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">No Unit</label>
          <input
            type="text"
            name="unitNumber"
            value={client.unitNumber || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">No Harta</label>
          <input
            type="text"
            name="accountNo"
            value={client.accountNo || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div className="col-span-2">
          <label className="block text-gray-600">Alamat Unit</label>
          <input
            type="text"
            name="unitAddress"
            value={client.unitAddress || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Amaun Bayaran</label>
          <input
            type="number"
            name="paymentAmount"
            value={client.paymentAmount || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Pusat Kutipan</label>
          <input
            type="text"
            name="collectionCenter"
            value={client.collectionCenter || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">No Resit</label>
          <input
            type="text"
            name="receiptNumber"
            value={client.receiptNumber || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Tarikh Resit</label>
          <input
            type="date"
            name="receiptDate"
            value={
              client.receiptDate
                ? client.receiptDate.split("T")[0]
                : "1970-01-01"
            }
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          />
        </div>

        <div>
          <label className="block text-gray-600">Status</label>
          <select
            name="status"
            value={client.status || ""}
            onChange={handleChange}
            className="border rounded-md w-full p-2"
          >
            <option value="Aktif">Aktif</option>
            <option value="Tidak Aktif">Tidak Aktif</option>
          </select>
        </div>

        <div className="col-span-2 flex justify-end mt-4">
          <button
            type="submit"
            disabled={saving}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            {saving ? "Saving..." : "Update"}
          </button>
        </div>
      </form>
    </div>
    </MainLayout>
  );
};

export default AirClientEdit;
